import React from 'react';
import { Typography } from '@mui/material';

const PercentComplete = ({ budgetData }) => {

    const getPercentComplete = () => {
        if (budgetData && budgetData.current_contract_summary && budgetData?.current_contract_summary?.percent_complete !== undefined) {
            return `${Math.round(budgetData.current_contract_summary.percent_complete)}%`;
        }
        return '--';
    };

    return (
        <div>
            <Typography style={{ textAlign: 'center' }} variant="body1" className="main-key-project-info-body">
                {getPercentComplete()}
            </Typography>
        </div>
    );
}

export default PercentComplete;
